import { Dialog } from "@mui/material";
import React from "react";
import { RiCloseLargeFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { DeleteuserAccount, Getusers } from "../Redux/Actions/AuthAction";

const DeleteAccount = ({
    debouncedSearch,
    Open,
    setOpen,
    user,
    page, setPage, cachedPages, setCachedPages,
    rowsPerPage
}) => {

    const dispatch = useDispatch();
    const { users, loading } = useSelector((state) => state.Auth);
    const handleclose = () => {
        setOpen(false);
    };


    const handledelete = async (e) => {
        e.preventDefault();
        
        if(user?.id){
            dispatch(DeleteuserAccount(user.id)).then(()=>{
                const remainingRecords = users?.data?.filter(record => record.id !== user?.id);
                
        
                if (remainingRecords?.length === 0) {
                    if (page > 1) {
                        setPage(prevPage => prevPage - 1);
                        dispatch(Getusers(page - 1,debouncedSearch, rowsPerPage)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                [page - 1]: res,
                            }));
                        });
                    } else {
                        setCachedPages((prev) => ({
                            ...prev,
                            [page]: [],
                        }));
    
                        dispatch(Getusers(1,debouncedSearch, rowsPerPage)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                1: res,
                            }));
                        });
    
                        setOpen(false);
                    }
                } else {
                    if (!cachedPages[page]) {
                        dispatch(Getusers(page,debouncedSearch, rowsPerPage)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                [page]: res,
                            }));
                        });
                    }
                }
                setOpen(false);

            })
        }
            
         
        
    };
    return (
        <>
            <Dialog
                open={Open}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "300px",
                    },
                }}
            >
                <div className="bg-white p-7  flex flex-col gap-5 rounded-2xl ">
                    <div className="flex  items-start justify-end w-full cursor-pointer">
                        <RiCloseLargeFill size={14} onClick={handleclose} />
                    </div>
                    <div className="  text-center flex flex-col justify-items-center gap-8">
                        <span className="bg-white rounded-full   text-center  mx-auto p-2 border-[2px] border-[#F1580C]">
                            <MdDelete fill="#F1580C" size={48} />
                        </span>

                        <div className="div">
                            <div className="text-[20px] font-[600]">Are you sure?</div>
                            <p>Do you really want to delete <b>{user?.first_name}{" "}{user?.last_name}</b>'s account? This action cannot be undone.</p>
                        </div>
                        <div className="flex gap-5  justify-center ">
                            <button
                                className="bg-transparent border border-[#CACACA] text-black rounded-lg  h-[40px]  w-full max-w-32   text-[14px] text-center"
                                onClick={handleclose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                onClick={handledelete}
                                style={{
                                    background:
                                        "linear-gradient(to right,#EF5A24 1%, #F38157 99%)",
                                }}
                                className="bg-[#ED3939] text-white rounded-lg  h-[40px]  w-full max-w-32   text-[14px] text-center flex justify-center items-center"
                            >
                                {loading ? (
                                    <div role="status">
                                        <svg
                                            aria-hidden="true"
                                            class="w-6 h-6 text-[#ED3939] animate-spin fill-white"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor"
                                            />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"
                                            />
                                        </svg>
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                ) : (
                                    `Delete`
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default DeleteAccount;
